import {ConversationAiStatusesEnum} from '../../models/api/conversationAiMarkModel';

export enum AiHarvestinModalActionTypesEnum {
  SET_CURRENTLY_SELECTED_TAG_INDEX = 'set_currently_selected_tag_index',
  SET_REVIEW_STATUS = 'set_mutation_status',
  REVIEW_SUCCESS = 'review_success',
  REVIEW_ERROR = 'review_error',
  GET_NEW_PAGE = 'get_new_page',
}

type State = {
  currentlySelectedTagIndex: number;
  messageIndex: number;
  currentCursor: number;
  reviewStatus?: ConversationAiStatusesEnum;
  hasError?: boolean;
};

type Action =
  | {type: AiHarvestinModalActionTypesEnum.SET_CURRENTLY_SELECTED_TAG_INDEX; payload: number}
  | {type: AiHarvestinModalActionTypesEnum.SET_REVIEW_STATUS; payload: ConversationAiStatusesEnum}
  | {type: AiHarvestinModalActionTypesEnum.REVIEW_SUCCESS}
  | {type: AiHarvestinModalActionTypesEnum.REVIEW_ERROR}
  | {type: AiHarvestinModalActionTypesEnum.GET_NEW_PAGE; payload: number | undefined};

export function aiHarvestingModalReducer(state: State, action: Action): State {
  switch (action.type) {
    case AiHarvestinModalActionTypesEnum.SET_CURRENTLY_SELECTED_TAG_INDEX:
      return {
        ...state,
        currentlySelectedTagIndex: action.payload,
        messageIndex: 0,
        currentCursor: 0,
        hasError: false,
      };
    case AiHarvestinModalActionTypesEnum.SET_REVIEW_STATUS:
      return {...state, reviewStatus: action.payload};
    case AiHarvestinModalActionTypesEnum.REVIEW_SUCCESS:
      return {...state, reviewStatus: undefined, messageIndex: state.messageIndex + 1, hasError: false};
    case AiHarvestinModalActionTypesEnum.REVIEW_ERROR:
      return {...state, hasError: true, reviewStatus: undefined};
    case AiHarvestinModalActionTypesEnum.GET_NEW_PAGE:
      return {...state, currentCursor: action.payload ?? state.currentCursor, messageIndex: 0};
    default:
      return state;
  }
}

export const initialState: State = {
  currentlySelectedTagIndex: 0,
  messageIndex: 0,
  currentCursor: 0,
  reviewStatus: undefined,
  hasError: false,
};
